import { gql } from '@apollo/client'

export const GET_ALL_CHANNEL_CONFIGS = gql`
  query GetAllChannelConfigs($organizationId: String) {
    allChannelConfigs(organizationId: $organizationId) {
      id
      ownerType
      ownerId
      ownerLabel
      organizationId
      organizationName
      twilioEnabled
      twilioPhoneNumber
      twilioAccountSidMasked
      whatsappProvider
      whatsappNumber
      whatsappAccountSidMasked
      emailEnabled
      emailFrom
      webhookToken
      webhookPaths
      updatedAt
      issues
    }
  }
`

export const GET_CHANNEL_COMMUNICATION_LOGS = gql`
  query GetChannelCommunicationLogs(
    $channelPhoneNumber: String!
    $channel: String
    $content: String
    $status: String
    $direction: String
    $createdAfter: Date
    $createdBefore: Date
    $after: String
  ) {
    allCommunications(
      first: 25
      after: $after
      channelPhoneNumber: $channelPhoneNumber
      channel: $channel
      content: $content
      status: $status
      direction: $direction
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      orderBy: "-created"
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          channel
          direction
          status
          content
          metadata
          created
          contact {
            id
            firstName
            lastName
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

export const SYNC_TWILIO_MESSAGES_NOW = gql`
  mutation SyncTwilioMessagesNow($channelPhoneNumber: String!, $channelKind: String!) {
    syncTwilioMessagesNow(channelPhoneNumber: $channelPhoneNumber, channelKind: $channelKind) {
      success
      created
      updated
      skipped
      error
    }
  }
`
